<script>
    import About from "./About.svelte";
</script>

<svelte:head>
    <title>SquareDojo 四角道場</title>
    <link rel='icon' type='image/png' href='images/favicon.png'>
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"/> 
    <meta name="title" content="Squaredojo - Work of Deepindera Dhanda">
<meta name="description" content="Site where Deepindera Dhanda's lists his latest digital work.  Web apps and mobile apps and tools">
<meta name="keywords" content="Squaredojo, Free Health App, Free App, LogMyPoop, Developer, Australia, Square dojo">
<meta name="robots" content="index, follow">
<meta http-equiv="Content-Type" content="text/html; charset=utf-8">
<meta name="language" content="English">
<meta name="revisit-after" content="30 days">
<meta name="author" content="Deepindera Dhanda">
 
</svelte:head>
<nav class="relative container m-auto p-2">
    <!-- Flex container-->
    <div class="flex items-center justify-between">
        <!-- Logo -->
        <div class="pt-2">
            <a href="/"><img
                src="../images/logo.svg"
                width="180"
                alt="Squaredojo logo"
            /></a>
        </div>
        <!-- Menu -->
        <div class="hidden md:flex space-x-6">
            <a href="#/contact" class="text-boyblue-500 hover:text-boyblue-900">Work</a>
            <a href="#/about" class="text-boyblue-500 hover:text-boyblue-900">About</a>
            <a href="/" class="text-boyblue-500 hover:text-boyblue-900">Contact</a>
        </div>
    </div>
</nav>
<!--hero section-->
<section id="hero">
    <div
        class="container flex flex-col-reverse md:flex-row mx-auto
         md:mt-10 mb-10 space-y-10 space-y-10 md:flex-row"
    >
        <!-- left item-->
        <div class="w-full mx-auto space-y-2 p-6 md:w-3/4">
            <h1 class="text-4xl text-center md:text-4xl font-gangofthree md:text-left">
                SQUARE DOJO
            </h1>
            <p class="text-center text-xl text-darkgrayishBlue md:text-left">
                Hello Friend. My name is <a
                    href="#/about"
                    class="text-boyblue-500 hover:text-boyblue-900"
                    >Deepindera</a>. Nice to meet you. 
                
                 <br />SquareDojo is a collection of my
                design , development and other work that i find interesting to
                share with you.
            </p>

             <div class="max-w-xl pt-6">
                <h2
                    class="text-xl text-left inline-block font-semibold text-gray-800"
                >
                    Get early access to my next app?
                </h2>

                <form name="form_notifynextapp" action="#" class="mt-2" netlify>
                    <div class="flex items-center">
                        <input
                            type="email"
                            class="w-full px-2 py-4 mr-2  bg-gray-100 shadow-inner rounded-md border border-gray-400 focus:outline-none"
                            required
                        />
                        <button
                            type="submit"
                            class="bg-primary-200 text-gray-200 px-5 py-2 rounded shadow hover:bg-boyblue-900"
                            style="margin-left: -7.0rem;">Sign Up</button
                        >
                    </div>
                </form>
            </div> 
        </div>
        <!-- image-->
        <div class="mx-auto p-6 block md:hidden lg:block">
            <img
                class="rounded-sm"
                src="images/hero.png"
                alt="SquareDojo Hero"
            />
        </div>
        <div class="hidden md:block md:pt-10 lg:hidden">
            <img
                class="rounded-sm"
                src="images/hero2.png"
                alt="SquareDojo Hero"
            />
        </div>
    </div>
</section>
<!-- features-->
<section class="relative container mx-auto mb-20">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"> 
        <div class="bg-white-200 p-6 rounded-md shadow-md">
            <img
            class="mx-auto h-36"
                src="images/featureicons_0001_Layer-4.png"
                alt="SquareDojo Team"
            />
            <h5 class="text-center text-gray-900 text-xl leading-tight font-medium p-4">
                People
            </h5>
            <p class="text-gray-700"> 
                Just getting started running 1 man show. Will be keen to partner with folks who have skills to compliment mine.
            </p>
        </div>
        <div class="bg-white-200 p-6 rounded-md shadow-md">
            <img
            class="mx-auto h-36"
            src="images/featureicons_0000_Layer-2.png"
            alt="SquareDojo Philosophy"
             />
            <h5 class="text-center text-gray-900 text-xl leading-tight font-medium p-4">
                Philosophy
            </h5>
            <p class="text-gray-700"> 
                Apps should be simple yet beautiful; intuitive yet not clunky, and free, or at least affordable even for a student.
            </p>
        </div>
        <div class="bg-white-200 p-6 rounded-md shadow-md">
            <img
            class="mx-auto h-36"
            src="images/featureicons_0004_Layer-6.png"
            alt="SquareDojo Current Work"
        />
            <h5 class="text-center text-gray-900 text-xl leading-tight font-medium p-4">
                Current Work
            </h5>
            <p class="text-gray-700"> 
                These days developing a health app for android. It is called LogMyPoop. Find out more about the <a href="#/logmypoop" title="LogMyPoop App" class="text-boyblue-500 hover:text-boyblue-900">app here</a>.
            </p>
        </div>
        <div class="bg-white-200 p-6 rounded-md shadow-md">
            <img
            class="mx-auto h-36"
            src="images/featureicons_0003_Layer-5.png"
            alt="SquareDojo Current Work"
        />
            <h5 class="text-center text-gray-900 text-xl leading-tight font-medium p-4">
                Contact
            </h5>
            <p class="text-gray-700"> 
                Best way to contact me is on twitter or  feel free to use <a href="#/contact" class="text-boyblue-500 hover:text-boyblue-900"> the form</a> to drop me a line. My timezone is +11 GMT.
            </p>
        </div>

    </div>
</section>

<footer class="text-center text-white" style="background-color: #0a4275;">
    <div class="container p-6" />
    <div
        class="text-center p-4"
        style="background-color: rgba(0, 0, 0, 0.2);"
    >
        2022 SquareDojo ありがとう<br /><br />
     
    </div>
</footer>
